<template>
    <div class="last_positions_item_container">
        <div class="last_positions_item">
            <div class="last_positions_item_cell position_cell">
                <router-link :to=" 'positions/' + position.id + '/evaluations' " >
                    <span >{{position.name}}</span>
                </router-link>
                <span class="ref_name">{{ getRefName(position.sight_ref) }}</span>
                <span class="rec_name" v-if="notOwnedPosition">{{ position.recruiter_name }}</span>
            </div>
            <div class="last_positions_item_cell actions_cell">
                <div class="action_triggers_container">

                    <div class="evals_number"  :class="{active: openedEvalsLists.includes(position.id)}">
                        <iconEval />
                        <div class="eval_count">{{ position.evaluations.length }}</div>
                    </div>

                </div>
            </div>
        </div>

        <div class="position_eval_list_container" :class="{opened: panelOpen}">
            <TablePositionsRowEvalsList
                :position="position"
                :evaluations="position.evaluations"
                :visibility="openedEvalsLists.includes(position.id) ? 'visible' : 'hidden' "
                @deleteEvalFromPosition="deleteEvalFromPosition"
                />
        </div>
    </div>

</template>

<script>
import TablePositionsRowEvalsList from '@/modules/positions/components/index/tablePositionsRowEvalsList'

export default {
    name: 'LastEvalsItem',
    props: {
        position: {
            required: true
        }
    },
    components: {
        TablePositionsRowEvalsList
    },
    data(){
        return {
            panelOpen: false,
            openedEvalsLists: [],
            userData: JSON.parse(localStorage.getItem('account')).user
       }
    },
    computed: {
        notOwnedPosition(){
            return this.userData.id != this.position.user_id
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        deleteEvalFromPosition(){
            console.log('to implement')
        },
        toggleEvalList(positionId){
            const index = this.openedEvalsLists.indexOf(positionId)
            if (index > -1){
                this.panelOpen = false
                this.openedEvalsLists.splice(index, 1)
            }else{
                this.panelOpen = true
                this.openedEvalsLists.push(positionId)
            }
        },
        evalIsOpened(evalId){
            return this.openedEval == evalId
        },
        openEvalModal(evalId){
            this.openedEval = evalId
        },
        onClose(){
            this.openedEval = -1
        },
        onConfirm(){

        }
    }
}


</script>

<style lang="scss">
.last_positions_item{
    display: flex;
    min-height: 60px;
    align-items: center;
    border-bottom: 1px solid $grey-lighter;
    background-color: $white-ter;
    .last_positions_item_cell{
        padding: 0 12px;
        display: flex;
    }
    .position_cell{
        width: 40%;
        flex-direction: column;
        align-items: flex-start;
        font-weight: 600;
        .ref_name{
            text-transform: uppercase;
            font-weight: 600;
            color: $grey-light;
            font-size: 0.85rem;
            text-align: left;
        }
        .rec_name{
            color: $primary;
        }
    }
    .actions_cell{
        width: 60%;
        flex-direction: column;
        .action_triggers_container{
            display: flex;
            align-items: flex-start;
            font-weight: 600;
            .evals_number{
                margin-left: 36px;
                display: flex;
                // cursor: pointer;
                user-select: none;
                svg{
                    height: 26px;
                    fill: $grey-light;
                }
                .eval_count{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 28px;
                    height: 28px;
                    background-color: $info;
                    border-radius: 100%;
                    color: $white;
                    font-weight: 600;
                    font-size: 1.25rem;
                    margin: 0 12px 0 6px;
                    border: 2px solid $info;
                    transition: .3s all;
                }
                &.active{
                    .eval_count{
                        color: $info;
                        background-color: $white;
                    }
                }
            }
        }
    }
}
.position_eval_list_container{
    overflow: hidden;
    margin-bottom: 18px;
    margin-left: 40%;
    transition: .5s all;
    &:not(.opened){
        transition: .5s all;
        height:0;
        margin-bottom: 0;
    }

}
</style>